// extracted by mini-css-extract-plugin
export default {"InputContainer":"InputForm_InputContainer__Ybi5S","error":"InputForm_error__h3B-n","blink":"InputForm_blink__+Sgy6"};